<template>
  <div>
    <barChartConfig
      v-if="barChartConfig"
      :chart="chart">
    </barChartConfig>
  </div>
</template>
<script>
  import barChartConfig from './chartConfigs/barChartConfig'
  export default {
    name: 'chartConfig',
    props: {
      chart: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    computed: {
      barChartConfig() {
        return this.chart.chartType == 10
      }
    },
    components: {
      barChartConfig
    }
  }
</script>


// WEBPACK FOOTER //
// chartConfig.vue?856cb2da